import { CreateTeacherContext } from "./_context";

export const CreateTeacherProvider = CreateTeacherContext.Provider